import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { IPermssionsByRol, IRol, IRolResponse } from 'src/app/core/interfaces/DB/i-rols';
import { IPermission, IAllPermsByRol } from 'src/app/core/interfaces/DB/i-permission';
import { RolService } from 'src/app/core/services/api/rol.service';
import {AlertService} from 'src/app/core/services/local/alert.service'
import { PermComponent } from './perm/perm.component';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { IResponse } from 'src/app/core/interfaces/Responses/i-responses';
import { AuthService } from 'src/app/core/services/api/auth.service';
import { MenuService } from 'src/app/core/services/local/menu.service';
import { LocalStorageService } from 'src/app/core/services/local/local-storage.service';

@Component({
  selector: 'app-perm-rol',
  templateUrl: './perm-rol.component.html',
  styleUrls: ['./perm-rol.component.scss']
})
export class PermRolComponent implements OnInit, AfterViewInit {

  textHeaderSelectedTab: string = 'Roles';
  listPermsNoAssign: IPermission[] = [];
  listPermsYesAssign: IPermission[] = [];
  listSelectRol!: IRol[];
  isLoadDataRoles: boolean = false;

  displayedColumns: string[] = [
    'Name',
    'Active',
    'Edit',
  ];

  dataSource!: IRol[];
  createdRol: IRol;
  rolesPermissionsForm!: FormGroup;

  constructor(
    private rolService: RolService,
    private alertService:  AlertService ,
    private menuService: MenuService,
    public dialog: MatDialog,
    public authService: AuthService,
    public localStorage: LocalStorageService,
    private cd: ChangeDetectorRef

  ) { }

  ngOnInit(): void {
    this.getRols();
    this.rolesPermissionsForm = this.createRolPermForm();
    this.loadRoles();
    this.menuService.titleName.next('Roles y Permisos')

  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  createRol() {
    this.openDialog(this.createEmpthyRol());
  }
  private createRolPermForm(): FormGroup {
    return new FormGroup({
      role: new FormControl('', Validators.compose([Validators.required])),
    });
  }
  editRol(element: IRol) {
    this.openDialog(element);
  }

  openDialog(_rol: IRol): void {
    const dialogRef = this.dialog.open(PermComponent, {
      width: '270px',
      data: _rol
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.createdRol = result;
        this.storeRol(this.createdRol);

      }
    });
  }


  // METODO CUANDO SE SELECCIONE UN TAB
  public activeTab(event: MatTabChangeEvent): void {
    this.textHeaderSelectedTab = 'Roles';
    switch (event.tab.textLabel) {
      case 'Roles':
      case 'Perms':
    }
  }

  createEmpthyRol() {
    let rol = {
      Id: 0,
      Active: true,
      Name: ''
    }

    return rol;

  }
  getPermsByRol() {
    let id = this.rolesPermissionsForm.get('role')?.value;
    this.rolService.GetAllPermissionsByRol(id).subscribe({
      next: (res: IResponse<IAllPermsByRol>) => {
        if (res.Result) {
          this.fillPerm(res.Data.AssignedPerms, res.Data.NoAssignedPerms);
        } else {
         
        }
      },
      error: (err: string) => {
        this.alertService.SimpleErrorAlert('Error', `${err}!`)
      },
    });


  }
  private fillPerm(
    param1: IPermission[],
    param2: IPermission[]
  ): void {
    this.listPermsNoAssign = param2;
    this.listPermsYesAssign = param1;
  }
  setPermissionsToCurrentRole(_current_rolid : number){
    let user = this.authService.currentUserValue;

    if(user.RolId == _current_rolid){
      this.localStorage.RemoveItem('perm');
      this.localStorage.SetItem('perm', this.listPermsYesAssign);
      this.authService.currentPermsSubject.next(this.listPermsYesAssign)
     
      //this.authService.SetPermissions(this.listPermsYesAssign);
    }


  }
  saveChangesPerms() {
    let id = this.rolesPermissionsForm.get('role')?.value;
    let perms : IPermssionsByRol = {
      RoleId: id,
      Perms: this.listPermsYesAssign
    }

    this.rolService.StorePermissionsByRol(perms).subscribe({
      next: (res: IResponse<boolean>) => {
        if (res) {
         this.setPermissionsToCurrentRole(id);
          this.alertService.Toast(2000, 'Cambios aplicados', 'top-end', 'success');
         
        } else {
          this.alertService.Toast(2000, 'Surgío un error', 'top-end', 'error'); 
        }
      },
      error: (err: string) => {
        this.alertService.SimpleErrorAlert('Error', `${err}!`)
      },
    });
  }
  getRols(): void {
    this.rolService.GetRols().subscribe({
      next: callback => {
        if (callback.Result) {
          this.dataSource = callback.Data!
          
        } else {
          console.log(callback.ErrorInfo.Message);
        }
      },
      error: error => console.log(error)
    })

  }
  storeRol(_rol: IRol): void {
    this.rolService.StoreRol(_rol).subscribe({
      next: callback => {
        if (callback) {
          this.getRols();
          this.alertService.SuccessAlert('¡Éxito!', 'Cambios guardados')
        } else {
          this.alertService.SimpleErrorAlert('Error', 'Hubo un error al guardar los cambios')
        }
      },
      error: error => console.log(error)
    })

  }
  OpenDialogRol() {

  }

  //DRAG AND DROP
  public drop(event: CdkDragDrop<IPermission[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      
      );
      this.saveChangesPerms();
    }
   
  }

  // METODO PARA MOVER TODOS
  public move(accion_: string) {
    if (accion_ === 'Asignados') {
      this.listPermsYesAssign.forEach((element) => {
        this.listPermsNoAssign.push(element);
      });

      this.listPermsYesAssign.length = 0;
    } else {
      this.listPermsNoAssign.forEach((element) => {
        this.listPermsYesAssign.push(element);
      });
      this.listPermsNoAssign.length = 0;
    }
    this.saveChangesPerms();
  }

  // METODO PARA CARGAR LOS USUARIOS Y MOSTRARLOS EN EL SELECT
  private loadRoles(): void {
    this.rolService.GetRols().subscribe({
      next: (res: IResponse<IRol[]>) => {
        if (res.Result) {
          this.listSelectRol = res.Data;
          this.isLoadDataRoles = true;
        } else {

        }
      },
      error: (err: string) => {

      },
    });
  }


}
